import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../assets/profile.jpeg'


const _hoisted_1 = {
  key: 0,
  class: "mt-4 space-y-2"
}
const _hoisted_2 = {
  href: "https://github.com/andrewmcodes/hyperui",
  target: "_blank",
  class: "block h-full p-4 border border-gray-700 rounded-lg hover:border-pink-600"
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex-none w-24 text-sm align-middle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "object-cover w-12 h-12 rounded-lg shadown-sm mx-auto",
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = { class: "font-medium text-black text-xs text-center" }
const _hoisted_8 = { class: "mt-1 text-md font-medium text-gray-600 flex-1" }

import { PropType } from "vue";
import CommentForm from "@/components/comments/CommentForm.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  comments: {
    type: Object as PropType<Comment[]>,
  },
  post_id: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const refresh = () => {
  console.log(props.post_id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommentForm, { post_id: __props.post_id }, null, 8, ["post_id"]),
    (__props.comments && __props.comments.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments, (comment) => {
            return (_openBlock(), _createElementBlock("li", {
              key: comment.content
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (comment.author.profile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "object-cover w-12 h-12 rounded-lg shadow-sm mx-auto",
                          src: comment.author.profile,
                          alt: ""
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                    _createElementVNode("h5", _hoisted_7, _toDisplayString(comment.author.first_name + " " + comment.author.last_name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(comment.content), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})